<template>
  <van-row class="card-wrap" type="flex" gutter="12">
    <van-col :span="12" v-for="(item, index) in box" :key="index">
      <div :class="['item', 'index-0' + (index + 1)]">
        <van-row type="flex" justify="center" :style="{ color: '#505050', fontWeight: 'bold' }">
          ￥{{ item.value }}
        </van-row>
        <van-row :style="{ color: '#808080', fontSize: '12px' }">
          {{ item.label }}
        </van-row>
      </div>
    </van-col>
  </van-row>
</template>

<script>
export default {
  props: ["box"],
  data() {
    return {};
  },
  watch: {},
};
</script>

<style lang="scss" scoped>
$pale-yellow: #fff4eb;
$pale-green: #dcf6f5;
$pale-blue: #edf3fc;
$pale-red: #ffedf1;
.card-wrap {
  padding: 16px;
  background-color: #fff;
  .item {
    margin: 6px 0;
    padding: 6px;
    border-radius: 5px;
    .van-row {
      margin: 4px;
    }
    &.index-01 {
      background-color: $pale-yellow;
    }
    &.index-02 {
      background-color: $pale-green;
    }
    &.index-03 {
      background-color: $pale-blue;
    }
    &.index-04 {
      background-color: $pale-red;
    }
  }
}
</style>
